module.exports = __webpack_public_path__ + "img/xxk.492769e4.png";